export default "__VITE_ASSET__BaFzn058__"